module.exports = __webpack_public_path__ + "img/array4.4f98dd35.png";